<template>
    <ion-app>
        <app-header :title="currentTabComponent.name" :back-button-title="'Log Out'"></app-header>
        <ion-content padding>
            <transition name="slide-left">
                <component :is="currentTabComponent" ref="currentTab"></component>
            </transition>
        </ion-content>

        <ion-footer>
            <tab-bar :items="tabbarItems" :show-selection="true" @tab="tabSelected"></tab-bar>
        </ion-footer>
    </ion-app>
</template>

<script>
import DocumentsView from '@/views/DocumentsView';
import StartView from '@/views/StartView';
import LoginView from '@/views/LoginView';

export default {
    name: 'TabBarControllerPage',
    components: {
        DocumentsView,
        StartView,
    },
    props: {},
    data() {
        return {
            currentTabComponent: StartView,
            tabbarItems: [{ title: 'Start', icon: 'menu' }, { title: 'Dokumente', icon: 'document-copy' }],
        };
    },
    computed: {},
    created() {
        this.$userEventBus.$on('loggedIn', this.loggedIn);
    },
    mounted() {
        console.log(this.$route.meta);
        this.tabSelected(this.$route.meta.tab);
    },
    methods: {
        tabSelected(index) {
            switch (index) {
                case 0:
                    this.currentTabComponent = StartView;
                    break;
                case 1:
                    if (this.$parse.User.current()) {
                        this.currentTabComponent = DocumentsView;
                    } else {
                        this.currentTabComponent = LoginView;
                    }
                    break;
            }
        },
        loggedIn() {
            this.tabSelected(1);
        },
    },
};
</script>

<style scoped></style>
